import React from "react";
import { Box } from "@mui/material";

interface ICoverPhotoPreviewProps {
  imageUrl: string;
}
export const CoverPhotoPreview: React.FC<ICoverPhotoPreviewProps> = ({
  imageUrl,
}) => {
  return (
    <Box
      sx={{
        width: "100%",
        padding: "10%",
        boxSizing: "border-box",
        backgroundImage: `url("${imageUrl}")`,
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
      }}
      data-cy="cover-photo-preview"
    />
  );
};
